module.exports = __webpack_public_path__ + "img/wasser.1c3b99c9.svg";